import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('donationBoxSettingsModalInfo', {
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    content: {
        title: 'Content',
        type: 'array',
        of: [
            {
                type: 'block'
            }
        ]
    }
}, []);
var validator = z.object({
    _type: z.literal('donationBoxSettingsModalInfo'),
    title: z.string().optional(),
    content: z.array(z.unknown()).refine(function(value) {
        return true;
    }).optional()
});
schema.donationBoxSettingsModalInfo;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=donationBoxSettingsModalInfo.js.map